import { render, staticRenderFns } from "./telGroup.vue?vue&type=template&id=2ded98da&scoped=true&"
import script from "./telGroup.vue?vue&type=script&lang=js&"
export * from "./telGroup.vue?vue&type=script&lang=js&"
import style0 from "./telGroup.vue?vue&type=style&index=0&id=2ded98da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ded98da",
  null
  
)

export default component.exports